(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.product-section-refresh"] && !Shopify.designMode) return;
  try {
    /*============================================================================
    kit-section-refresh
    - Listens for `shopify:product:select` with `{detail: {html}}` section payload
    - Supports only server-rendered markup (no inputs or other dynamic content)
    - Use `data-kit-refresh="<name>"` to mark the regions to replace

    Replaces the variant-dependent regions of a product section with the
    server-rendered markup the variant picker already fetched, so a theme does
    not need client-side code to recompute price, inventory, SKU or button state.
  ==============================================================================*/

  if (!customElements.get('kit-section-refresh')) {
    class KitSectionRefresh extends HTMLElement {
      #selectionId = 0;
      #abortController = null;

      get sectionId() {
        return this.dataset.sectionId;
      }

      get productId() {
        return this.dataset.productId;
      }

      get root() {
        const selector = this.dataset.root;

        if (selector) return this.closest(selector);

        return this.closest('.shopify-section');
      }

      connectedCallback() {
        this.#abortController = new AbortController();

        document.addEventListener('shopify:product:select', event => this.#select(event), {
          signal: this.#abortController.signal,
        });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
      }

      #owns(picker) {
        if (!(picker instanceof HTMLElement) || !picker.matches('kit-variant-picker')) return false;
        if (this.sectionId && picker.dataset.sectionId !== this.sectionId) return false;
        if (this.productId && picker.dataset.productId !== this.productId) return false;

        return true;
      }

      async #select(event) {
        const picker = event.target;
        const root = this.root;

        if (!this.#owns(picker)) return;

        if (!root) {
          console.warn('Section refresh: no root element to refresh within.', this);
          return;
        }

        const selectionId = ++this.#selectionId;
        this.#setBusy(root, true);

        try {
          const result = await event.promise;

          // A newer selection owns the outcome
          if (selectionId !== this.#selectionId) return;

          // Follow the picker to its new product (combined listings)
          this.dataset.productId = picker.dataset.productId;

          const regionMap = this.#fetchedRegions(result);

          if (!regionMap) {
            console.warn('Section refresh: the variant picker resolved without a section document.', result);
            return;
          }

          this.#apply(root, regionMap, picker);
        } catch (error) {
          if (error?.name === 'AbortError') return;
          if (selectionId !== this.#selectionId) return;

          console.error('Section refresh failed:', error);
        } finally {
          if (selectionId === this.#selectionId) this.#setBusy(root, false);
        }
      }

      #fetchedRegions(result) {
        const html = result?.detail?.html;

        if (!html) return null;

        const selector = this.dataset.root;
        const scope = selector ? html.querySelector(selector) : html;

        if (!scope) {
          console.warn(`Section refresh: root "${selector}" not found in the fetched section.`, html);
          return null;
        }

        const byName = new Map();

        scope.querySelectorAll('[data-kit-refresh]').forEach(element => {
          const name = element.dataset.kitRefresh;

          if (!byName.has(name)) byName.set(name, []);

          // Instances (e.g. mobile + desktop copies) accessible by index
          byName.get(name).push(element);
        });

        return byName;
      }

      #apply(root, fetchedRegions, picker) {
        const counts = new Map();

        root.querySelectorAll('[data-kit-refresh]').forEach(target => {
          const name = target.dataset.kitRefresh;
          const instanceIndex = counts.get(name) ?? 0;
          counts.set(name, instanceIndex + 1);

          // Skip picker itself
          if (picker.contains(target) || target.contains(picker)) return;

          const source = fetchedRegions.get(name)?.[instanceIndex];

          if (!source) return;

          // Cloned to allow re-use of the source element
          target.replaceWith(source.cloneNode(true));
        });
      }

      #setBusy(root, busy) {
        if (busy) {
          root.setAttribute('data-kit-refresh-busy', '');
          root.setAttribute('aria-busy', 'true');
        } else {
          root.removeAttribute('data-kit-refresh-busy');
          root.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('kit-section-refresh', KitSectionRefresh);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.product-variant-picker"] && !Shopify.designMode) return;
  try {
    /*============================================================================
    kit-variant-picker
    - For quick shop, fetch the full merchant-configured product page and set
    the correct section id on the picker

    Events:
    - shopify:product-select
    - kit:variant-picker:change (legacy)
    - kit:variant-picker:after-change (legacy)
    - kit:variant-picker:error (legacy)
  ==============================================================================*/

  if (!customElements.get('kit-variant-picker')) {
    class KitVariantPicker extends HTMLElement {
      #abortController = null;
      #standardEventsReady = null;
      // Prevents race conditions between completed requests
      #selectionId = 0;
      #chosenOptions = new Map();

      get sectionId() {
        return this.dataset.sectionId;
      }

      set sectionId(value) {
        this.dataset.sectionId = value;
      }

      connectedCallback() {
        this.#readIdentity();
        this.selectedVariant = JSON.parse(this.querySelector('[data-kit-selected-variant]')?.textContent ?? 'null');
        this.shouldUpdateUrl = 'updateUrl' in this.dataset;
        this.allowUnselected = 'allowUnselected' in this.dataset;
        this.soldOutLabelTemplate = this.querySelector('template[data-sold-out-label-template]');
        this.soldOutLabel = this.soldOutLabelTemplate.content.querySelector('[data-sold-out-label]').textContent;
        this.#resolveAvailability();
        this.#echoChoices();
        this.#standardEventsReady = this.#loadStandardEvents();
        this.addEventListener('change', this.#onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.#onChange);
        this.#abortController?.abort();
      }

      #readIdentity(el = this) {
        this.productId = el.dataset.productId;
        this.productTitle = el.dataset.productTitle;
        this.productHandle = el.dataset.productHandle;
        this.productUrl = el.dataset.productUrl;
        this.variantId = el.dataset.variantId;

        if (el !== this) {
          this.dataset.productId = el.dataset.productId;
          this.dataset.productTitle = el.dataset.productTitle;
          this.dataset.productHandle = el.dataset.productHandle;
          this.dataset.productUrl = el.dataset.productUrl;
          this.dataset.variantId = el.dataset.variantId;
        }
      }

      async #loadStandardEvents() {
        try {
          this.SE = await import('https://cdn.shopify.com/storefront/standard-events.js');
        } catch (error) {
          console.error('Failed to load the Shopify Standard Events module.', error);
        }
      }

      async #onChange(event) {
        const trigger = event.target;

        if (!(trigger instanceof HTMLElement) || !trigger.matches('input[type="radio"], select')) {
          return;
        }

        const selectedOption = trigger.tagName === 'SELECT'
          ? trigger.options[trigger.selectedIndex]
          : trigger.closest('[data-option-value-id]');
        const optionValueId = selectedOption?.dataset.optionValueId;
        const productUrl = selectedOption?.dataset.productUrl;
        const previous = {
          product: this.#product(),
          variantId: this.variantId
        };

        // Remember the selections and check if all options are chosen (for unselected picker)
        let incomplete = false;
        if (this.allowUnselected) {
          this.#getSelectedOptions().forEach(option => this.#chosenOptions.set(option.name, option.id));
          incomplete = this.selectionIncomplete;
        }

        const deferred = await this.#dispatchChange(productUrl, previous, incomplete);
        if (!deferred) return;

        const selectionId = ++this.#selectionId;

        try {
          const html = await this.#refresh(optionValueId, productUrl, selectionId, incomplete);
          const viewEventPayloadEl = html.querySelector('kit-variant-picker [data-view-event-payload]');
          const viewPayload = JSON.parse(viewEventPayloadEl?.textContent?.trim() ?? 'null');
          const viewEventVariant = viewPayload?.product?.selectedVariant ?? null;

          this.#dispatchAfterChange(html, this.selectedVariant, viewEventVariant, deferred, previous);
        } catch (error) {
          deferred.reject(error);

          // Ignore errors triggered by aborted/superseded requests
          if (error.name === 'AbortError') return;
          if (selectionId !== this.#selectionId) return;

          console.error(error);
          this.#dispatchError(error, productUrl, previous);
        }
      }

      async #refresh(changedOptionValueId, productUrl, selectionId, incomplete) {
        const sectionRequestUrl = this.#variantUrl(productUrl);
        sectionRequestUrl.searchParams.set('section_id', this.sectionId);

        this.#abortController?.abort();
        const refreshAbortController = new AbortController();
        this.#abortController = refreshAbortController;

        this.#setLoading();
        try {
          const sectionRequest = await fetch(sectionRequestUrl, { signal: refreshAbortController.signal });

          if (!sectionRequest.ok) {
            throw new Error(`Variant section request failed with ${sectionRequest.status}`);
          }

          const sectionResponse = await sectionRequest.text();
          const sectionHtml = new DOMParser().parseFromString(sectionResponse, 'text/html');
          const newPicker = sectionHtml.querySelector('kit-variant-picker');

          if (!newPicker) {
            throw new Error('<kit-variant-picker> not found');
          }

          // In case a new request begins after the current request can be aborted
          if (selectionId !== this.#selectionId) {
            throw new DOMException('Superseded by a newer selection', 'AbortError');
          }

          this.innerHTML = newPicker.innerHTML;
          this.#readIdentity(newPicker);
          this.selectedVariant = JSON.parse(this.querySelector('[data-kit-selected-variant]')?.textContent ?? 'null');
          this.#reconcileSelections();
          this.#resolveAvailability();
          this.#echoChoices();

          if (incomplete) {
            this.variantId = '';
            this.dataset.variantId = '';
            this.selectedVariant = null;
            this.querySelector('[data-variants]')?.remove();
          }

          this.#restoreFocus(changedOptionValueId);
          this.#updateHistory(this.variantId, productUrl);

          return sectionHtml;
        } finally {
          // Clear loading state if the current request was not superseded
          if (selectionId === this.#selectionId) {
            this.#unsetLoading();
          }
        }
      }

      async #dispatchChange(productUrl, previous, incomplete) {
        const changeEvent = this.#emit('change', {
          picker: this,
          previousVariant: previous.variantId,
          product: previous.product,
          sectionId: this.sectionId,
          selectedOptions: this.#getSelectedOptions().map(({ name, value }) => ({ name, value })),
          selectionIncomplete: incomplete
        }, { cancelable: true });

        if (changeEvent.defaultPrevented) return null;

        // Unselected: still refresh to narrow availability, but no variant reporting
        if (incomplete) return { resolve() { }, reject() { } };

        await this.#standardEventsReady;
        if (!this.SE?.ProductSelectEvent) {
          this.#navigate(productUrl);
          return null;
        }

        const deferred = this.SE.ProductSelectEvent.createPromise();
        this.#standardDispatch({ promise: deferred.promise });
        return deferred;
      }

      #dispatchAfterChange(html, selectedVariant, viewEventVariant, deferred, previous) {
        this.#emit('after-change', {
          html,
          picker: this,
          previousProduct: previous.product,
          previousVariant: previous.variantId,
          product: this.#product(),
          productChanged: previous.product.id !== this.productId,
          sectionId: this.sectionId,
          selectedOptions: this.#getSelectedOptions().map(({ name, value }) => ({ name, value })),
          selectionIncomplete: this.selectionIncomplete,
          variant: selectedVariant
        });

        deferred.resolve({
          detail: { html },
          variant: viewEventVariant
        });
      }

      #dispatchError(error, productUrl, previous) {
        const errorEvent = this.#emit('error', {
          error,
          picker: this,
          previousVariant: previous.variantId,
          product: previous.product,
          sectionId: this.sectionId
        }, { cancelable: true });

        if (!errorEvent.defaultPrevented) {
          this.#navigate(productUrl);
        }
      }

      #standardDispatch({ promise }) {
        const selectedOptions = this.#getSelectedOptions().map(({ name, value }) => {
          return { name, value };
        });

        this.dispatchEvent(new this.SE.ProductSelectEvent({
          selectedOptions,
          product: {
            id: this.productId,
            title: this.productTitle,
            handle: this.productHandle
          },
          promise
        }));
      }

      #product() {
        return {
          id: this.productId,
          title: this.productTitle,
          handle: this.productHandle,
          url: this.productUrl
        };
      }

      #emit(type, detail, { cancelable = false } = {}) {
        const event = new CustomEvent(`kit:variant-picker:${type}`, {
          bubbles: true,
          cancelable,
          detail
        });

        this.dispatchEvent(event);
        return event;
      }

      #navigate(productUrl) {
        const url = this.#variantUrl(productUrl);

        this.#setLoading();
        window.location.assign(url.toString());
      }

      get selectionIncomplete() {
        if (!this.allowUnselected) return false;

        const names = new Set();
        const chosen = new Set();

        this.querySelectorAll('[data-option-name]').forEach(el => {
          const { optionName } = el.dataset;

          names.add(optionName);

          const isChosen = el.tagName === 'SELECT'
            ? el.value !== ''
            : el.querySelector('input[type="radio"]:checked') !== null;

          if (isChosen) chosen.add(optionName);
        });

        return chosen.size < names.size;
      }

      #getSelectedOptions() {
        return [...this.querySelectorAll('input[type="radio"]:checked, select')].map(el => {
          if (el.tagName === 'SELECT') {
            return {
              name: el.dataset.optionName,
              value: el.options[el.selectedIndex]?.value,
              id: el.options[el.selectedIndex]?.dataset.optionValueId
            };
          } else if (el.tagName === 'INPUT') {
            return {
              name: el.closest('[data-option-name]')?.dataset.optionName,
              value: el.value,
              id: el.closest('[data-option-value-id]')?.dataset.optionValueId
            };
          }
        }).filter(option => option.name && option.value && option.id);
      }

      // Since refresh resolves some variant, clear selections that were not chosen
      #reconcileSelections() {
        if (!this.allowUnselected) return;

        [...this.querySelectorAll('[data-option-name]')].forEach(el => {
          const chosenValueId = this.#chosenOptions.get(el.dataset.optionName);

          if (el.tagName === 'SELECT') {
            const match = chosenValueId
              && [...el.options].find(option => option.dataset.optionValueId === chosenValueId);

            if (match) {
              el.value = match.value;
            } else {
              const placeholder = [...el.options].find(option => option.value === '');
              if (placeholder) placeholder.disabled = false;
              el.value = '';
            }
          } else {
            const input = el.querySelector('input[type="radio"]');
            if (input) input.checked = Boolean(chosenValueId) && el.dataset.optionValueId === chosenValueId;
          }
        });
      }

      // Proper availability resolution for incomplete selections (Shopify defaults to a fallback variant's values)
      #resolveAvailability() {
        if (!this.selectionIncomplete && this.selectedVariant) return;

        const availableOptions = JSON.parse(this.querySelector('[data-kit-available-options]')?.textContent ?? 'null');

        // High-variant products and combined listings
        if (!availableOptions) {
          this.#resetUnresolvedAvailability();
          return;
        }

        // With nothing chosen, the server already rated every value against these variants
        const anyChosen = [...this.querySelectorAll('fieldset')].some(fieldset => this.#chosenValue(fieldset) !== null);
        if (anyChosen) this.#applyTrueAvailability(availableOptions);
      }

      #applyTrueAvailability(availableOptions) {
        const chosen = [];

        this.querySelectorAll('fieldset').forEach((fieldset, index) => {
          const matchesEarlierChoices = options => chosen.every((chosenValue, i) => {
            const isUnchosen = chosenValue === null;
            const isMatchingChoice = options[i] === chosenValue;

            return isUnchosen || isMatchingChoice;
          });

          // Mark available if the combination with earlier choices belongs to an available variant
          this.#markAvailability(fieldset, value => {
            return availableOptions.some(options => {
              const isMatchingValue = options[index] === value;

              return isMatchingValue && matchesEarlierChoices(options);
            });
          });

          chosen.push(this.#chosenValue(fieldset));
        });
      }

      // Resets availability for unresolved options
      #resetUnresolvedAvailability() {
        let earlierChosen = true;

        this.querySelectorAll('fieldset').forEach(fieldset => {
          if (!earlierChosen) this.#markAvailability(fieldset, () => true);

          earlierChosen = earlierChosen && this.#chosenValue(fieldset) !== null;
        });
      }

      #chosenValue(fieldset) {
        const select = fieldset.querySelector('select');

        return select
          ? select.value || null
          : fieldset.querySelector('input[type="radio"]:checked')?.value ?? null;
      }

      #markAvailability(fieldset, isAvailable) {

        fieldset.querySelectorAll('option:not([value=""])').forEach(option => {
          const available = isAvailable(option.value);

          option.textContent = available ? option.value : `${option.value}${this.soldOutLabel}`;
        });

        fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
          const available = isAvailable(input.value);
          const radio = input.closest('[data-option-value-id]');

          radio?.querySelector('.kit-button')?.classList.toggle('kit-button--disabled', !available);
          radio?.querySelector('.kit-swatch')?.classList.toggle('kit-swatch--disabled', !available);

          // Keeps the screen-reader sold-out label in step with the visual marking
          const label = radio?.querySelector('[data-sold-out-label]');
          if (available) {
            label?.remove();
          } else if (!label) {
            radio?.append(this.soldOutLabelTemplate.content.cloneNode(true));
          }
        });
      }

      #echoChoices() {
        this.querySelectorAll('input[type="radio"]:checked').forEach(input => {
          const selection = input.closest('fieldset')?.querySelector('.kit-fieldset__legend-selection');

          if (selection) selection.textContent = input.value;
        });
      }

      #variantUrl(productUrl) {
        const url = new URL(productUrl || this.productUrl, window.location.origin);
        const optionValues = this.#getSelectedOptions()
          .map(option => option.id)
          .join(',');

        url.searchParams.set('option_values', optionValues);
        return url;
      }

      #updateHistory(variantId, productUrl) {
        if (!this.shouldUpdateUrl || window.Shopify?.designMode) return;

        const url = new URL(window.location.href);

        if (productUrl) {
          url.pathname = new URL(productUrl, window.location.origin).pathname;
        }

        if (variantId) {
          url.searchParams.set('variant', variantId);
        } else {
          url.searchParams.delete('variant');
        }

        window.history.replaceState({}, '', url.toString());
      }

      #restoreFocus(optionValueId) {
        const option = this.querySelector(`[data-option-value-id="${optionValueId}"]`);

        if (!option) return;
        if (option.tagName === 'OPTION' && !matchMedia('(pointer: coarse)').matches) {
          option.closest('select')?.focus();
        } else {
          (option.querySelector('input') || option).focus();
        }
      }

      #setLoading() {
        this.classList.add('kit-picker--loading');
      }

      #unsetLoading() {
        this.classList.remove('kit-picker--loading');
      }
    }

    customElements.define('kit-variant-picker', KitVariantPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.tooltip"] && !Shopify.designMode) return;
  try {
    const FLIPS = { top: 'bottom', bottom: 'top', start: 'end', end: 'start' };
  const VIEWPORT_MARGIN = 4;
  const MIN_ARROW_INSET = 12;
  const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

  // After one tooltip is shown, neighbouring triggers open instantly for a short period.
  const WARM_WINDOW = 300;
  let warmUntil = 0;

  // Only one tooltip on the page is open at a time
  let openTooltip = null;

  class KitTooltip extends HTMLElement {
    #abortController = null;
    #openAbortController = null;
    #showTimeout = null;
    #placement = String();
    #delay = Number();
    #showOnFocus = Boolean();
    #isRTL = Boolean();
    #trigger = null;
    #bubble = null;

    connectedCallback() {
      this.#placement = this.getAttribute('placement') || 'top';
      this.#delay = Number(this.getAttribute('delay')) || 0;
      this.#showOnFocus = this.getAttribute('show-on-focus') !== 'false';
      this.#trigger = this.querySelector('.kit-tooltip__trigger');
      this.#bubble = this.querySelector('.kit-tooltip__bubble');
      this.#isRTL = getComputedStyle(this).direction === 'rtl';

      if (this.#isRTL && !this.matches(':dir(rtl)')) this.setAttribute('dir', 'rtl');

      if (!this.#trigger || !this.#bubble) return;

      this.#wireDescription();

      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#trigger.addEventListener('mouseenter', () => this.#scheduleShow(), { signal });
      this.#trigger.addEventListener('mouseleave', () => this.#hide(), { signal });
      this.#trigger.addEventListener('focusout', () => this.#hide(), { signal });

      if (this.#showOnFocus) {
        this.#trigger.addEventListener(
          'focusin',
          (event) => {
            if (event.target instanceof Element && event.target.matches(':focus-visible')) this.#show();
          },
          { signal }
        );
      }

      // Hide until measured, or it flashes at the previous position
      this.#bubble.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') this.#bubble.style.visibility = 'hidden';
        },
        { signal }
      );

      this.#bubble.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.#bubble.style.visibility = '';
            this.#trackWhileOpen();
          } else {
            this.#openAbortController?.abort();
            this.#openAbortController = null;
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      if (openTooltip === this) openTooltip = null;
      this.#abortController?.abort();
      this.#openAbortController?.abort();
      clearTimeout(this.#showTimeout);
    }

    #trackWhileOpen() {
      this.#openAbortController?.abort();
      this.#openAbortController = new AbortController();

      window.addEventListener('resize', () => this.#position(), {
        passive: true,
        signal: this.#openAbortController.signal,
      });

      document.addEventListener('keydown', (event) => event.key === 'Escape' && this.#hide(), {
        signal: this.#openAbortController.signal,
      });
    }

    // The focusable element is usually nested (a radio inside a label)
    #wireDescription() {
      if (this.#bubble.getAttribute('aria-hidden') === 'true') return;

      const describable = this.#trigger.querySelector(
        'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (describable && !describable.hasAttribute('aria-describedby')) {
        describable.setAttribute('aria-describedby', this.#bubble.id);
      }
    }

    #scheduleShow() {
      // Tapping fires a synthetic mouseenter; only real hover should open
      if (!FINE_POINTER.matches) return;

      clearTimeout(this.#showTimeout);

      if (Date.now() < warmUntil) {
        this.#show();
        return;
      }

      this.#showTimeout = setTimeout(() => this.#show(), this.#delay);
    }

    #show() {
      clearTimeout(this.#showTimeout);
      if (this.#bubble.matches(':popover-open')) return;

      openTooltip?.#hide();
      openTooltip = this;

      this.setAttribute('placement', this.#placement);
      this.#bubble.showPopover();
    }

    #hide() {
      clearTimeout(this.#showTimeout);
      if (openTooltip === this) openTooltip = null;
      if (!this.#bubble.matches(':popover-open')) return;

      this.#bubble.hidePopover();
      this.setAttribute('placement', this.#placement);
      warmUntil = Date.now() + WARM_WINDOW;
    }

    #position() {
      const anchor = this.#trigger.getBoundingClientRect();
      const width = this.#bubble.offsetWidth;
      const height = this.#bubble.offsetHeight;
      const offset = parseFloat(getComputedStyle(this.#bubble).getPropertyValue('--kit-tooltip-offset')) || 0;
      const vw = document.documentElement.clientWidth;
      const vh = document.documentElement.clientHeight;

      let placement = this.#placement;
      let box = this.#boxFor(placement, anchor, width, height, offset);

      if (!this.#fits(box, width, height, vw, vh)) {
        const flipped = this.#boxFor(FLIPS[placement], anchor, width, height, offset);

        if (this.#fits(flipped, width, height, vw, vh)) {
          placement = FLIPS[placement];
          box = flipped;
        }
      }

      this.setAttribute('placement', placement);

      const left = clamp(box.left, VIEWPORT_MARGIN, Math.max(VIEWPORT_MARGIN, vw - VIEWPORT_MARGIN - width));
      const top = clamp(box.top, VIEWPORT_MARGIN, Math.max(VIEWPORT_MARGIN, vh - VIEWPORT_MARGIN - height));

      this.#bubble.style.left = `${Math.round(left + window.scrollX)}px`;
      this.#bubble.style.top = `${Math.round(top + window.scrollY)}px`;

      this.#positionArrow(placement, anchor, { height, left, top, width });
    }

    // Keep the arrow on the trigger after clamping
    #positionArrow(placement, anchor, box) {
      const isVertical = placement === 'top' || placement === 'bottom';
      const anchorCenter = isVertical ? anchor.left + anchor.width / 2 : anchor.top + anchor.height / 2;
      const bubbleCenter = isVertical ? box.left + box.width / 2 : box.top + box.height / 2;
      const limit = Math.max(0, (isVertical ? box.width : box.height) / 2 - MIN_ARROW_INSET);

      this.#bubble.style.setProperty('--arrow-offset', `${clamp(anchorCenter - bubbleCenter, -limit, limit)}px`);
    }

    #boxFor(placement, anchor, width, height, offset) {
      // start/end are logical, so they swap sides in RTL
      const beforeAnchor = anchor.left - offset - width;
      const afterAnchor = anchor.right + offset;
      const centeredTop = anchor.top + anchor.height / 2 - height / 2;

      switch (placement) {
        case 'bottom':
          return { left: anchor.left + anchor.width / 2 - width / 2, top: anchor.bottom + offset };
        case 'start':
          return { left: this.#isRTL ? afterAnchor : beforeAnchor, top: centeredTop };
        case 'end':
          return { left: this.#isRTL ? beforeAnchor : afterAnchor, top: centeredTop };
        default:
          return { left: anchor.left + anchor.width / 2 - width / 2, top: anchor.top - offset - height };
      }
    }

    #fits(box, width, height, vw, vh) {
      if (this.#placement === 'top' || this.#placement === 'bottom') {
        return box.top >= VIEWPORT_MARGIN && box.top + height <= vh - VIEWPORT_MARGIN;
      }

      return box.left >= VIEWPORT_MARGIN && box.left + width <= vw - VIEWPORT_MARGIN;
    }
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  customElements.define('kit-tooltip', KitTooltip);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["roxari-main-gemstone-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const link=event.target.closest('[data-rx-gem-link]');if(!link||event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;const target=new URL(link.href,location.origin);const current=new URL(location.href);current.searchParams.forEach((value,key)=>{if(key.startsWith('preview_')||key==='_fd'||key==='pb')target.searchParams.set(key,value)});const theme=window.Shopify&&window.Shopify.theme;if(theme&&theme.role==='unpublished'&&theme.id)target.searchParams.set('preview_theme_id',String(theme.id));event.preventDefault();location.assign(target.href)});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["roxari-moissanite-shape-filter"] && !Shopify.designMode) return;
  try {
    (function(){
  const allowedShapes=['round','oval','emerald','princess','pear','cushion','radiant','asscher','heart','marquise'];

  function initialize(root){
    if(root.dataset.rxInitialized==='true')return;
    const host=root.closest('.collection-content');
    const grid=host?.querySelector('#CollectionAjaxContent .collection-grid__wrapper > .grid.grid--uniform');
    if(!host||!grid)return;
    root.dataset.rxInitialized='true';
    const status=root.querySelector('.rx-moissanite-shape-filter__status');
    const links=Array.from(root.querySelectorAll('[data-rx-shape-choice]'));
    const caratButtons=Array.from(root.querySelectorAll('[data-rx-carat-button]'));
    const allowedCarats=caratButtons.map(button=>button.dataset.rxCaratButton).filter(value=>value!=='all');
    const source=root.dataset.rxSource;
    const originalNodes=Array.from(grid.childNodes);
    const pagination=host.querySelector('#CollectionAjaxContent .pagination')||host.querySelector('#CollectionAjaxContent .pagination-wrapper');
    let feed=null, loadPromise=null, generation=0;
    function currentFilters(){
      const params=new URL(location.href).searchParams;
      const rawShape=params.get('rx_shape')||'all';
      const rawCarat=params.get('rx_carat')||'all';
      return {
        shape:allowedShapes.includes(rawShape)?rawShape:'all',
        carat:allowedCarats.includes(rawCarat)?rawCarat:'all'
      };
    }
    function showStatus(value){status.textContent=value;status.hidden=!value;}
    function markActive(shape,carat){
      links.forEach(link=>{
        const selected=link.dataset.rxShapeChoice===shape;
        link.classList.toggle('is-selected',selected);
        if(selected)link.setAttribute('aria-current','page');
        else link.removeAttribute('aria-current');
      });
      caratButtons.forEach(button=>{const active=button.dataset.rxCaratButton===carat;button.classList.toggle('is-selected',active);button.setAttribute('aria-pressed',String(active))});
    }
    function fetchFeed(){
      if(feed)return Promise.resolve(feed);
      if(loadPromise)return loadPromise;
      const url=new URL(source,location.origin);
      url.searchParams.set('section_id','roxari-moissanite-shape-feed');
      const page=new URL(location.href);
      for(const key of ['preview_theme_id','_fd','pb','preview_token']){
        if(page.searchParams.has(key))url.searchParams.set(key,page.searchParams.get(key));
      }
      loadPromise=fetch(url.href,{credentials:'same-origin'}).then(res=>{
        if(!res.ok)throw Error('HTTP '+res.status);
        return res.text();
      }).then(html=>{
        const doc=new DOMParser().parseFromString(html,'text/html');
        const items=Array.from(doc.querySelectorAll('template[data-rx-product-shape]'));
        if(!items.length)throw Error('No product feed returned');
        feed=items;
        const shapes=new Set(items.map(item=>item.dataset.rxProductShape).filter(Boolean));
        const carats=new Set(items.map(item=>item.dataset.rxProductCarat).filter(Boolean));
        links.forEach(link=>{
          const key=link.dataset.rxShapeChoice;
          const disabled=key!=='all'&&!shapes.has(key);
          link.classList.toggle('is-unavailable',disabled);
          link.setAttribute('aria-disabled',disabled?'true':'false');
        });
        caratButtons.forEach(button=>{button.disabled=button.dataset.rxCaratButton!=='all'&&!carats.has(button.dataset.rxCaratButton)});
        return items;
      }).catch(err=>{loadPromise=null;throw err;});
      return loadPromise;
    }
    async function display(shape,carat){
      const ticket=++generation;
      markActive(shape,carat);
      if(shape==='all'&&carat==='all'){
        grid.replaceChildren(...originalNodes);
        if(pagination)pagination.hidden=false;
        showStatus('');
        grid.style.opacity='';
        grid.style.minHeight='';
        return;
      }
      showStatus('Loading matching jewellery…');
      grid.style.opacity='0.4';
      grid.style.minHeight='150px';
      try{
        const items=await fetchFeed();
        if(ticket!==generation)return;
        const matches=items.filter(item=>
          (shape==='all'||item.dataset.rxProductShape===shape)&&
          (carat==='all'||item.dataset.rxProductCarat===carat)
        );
        const fragment=document.createDocumentFragment();
        for(const template of matches){
          const card=template.content.firstElementChild?.cloneNode(true);
          if(!card)continue;
          // Feed cards are inserted after the theme's initial image-animation setup.
          // Replace its one-time <image-element> component with a visible native
          // image wrapper so filtered images render on desktop and mobile.
          card.querySelectorAll('image-element').forEach(element=>{
            const wrapper=document.createElement('span');
            wrapper.className='rx-filtered-image-wrapper';
            wrapper.style.cssText='display:block;position:relative;width:100%;height:100%;opacity:1;visibility:visible;';
            while(element.firstChild)wrapper.appendChild(element.firstChild);
            element.replaceWith(wrapper);
          });
          card.querySelectorAll('[data-aos]').forEach(element=>{
            element.removeAttribute('data-aos');
            element.classList.remove('aos-init');
            element.classList.add('aos-animate');
          });
          card.removeAttribute('data-aos');
          card.classList.remove('aos-init');
          card.classList.add('aos-animate');
          card.querySelectorAll('img').forEach(img=>{
            if(!img.getAttribute('src')&&img.dataset.src)img.src=img.dataset.src;
            if(!img.getAttribute('srcset')&&img.dataset.srcset)img.srcset=img.dataset.srcset;
            img.loading='eager';
            img.style.setProperty('opacity','1','important');
            img.style.setProperty('visibility','visible','important');
          });
          fragment.appendChild(card);
        }
        grid.replaceChildren(fragment);
        if(pagination)pagination.hidden=true;
        showStatus(matches.length?'':'No products with confirmed matching shape and carat weight. Select another filter or All.');
      }catch(err){
        if(ticket!==generation)return;
        showStatus('Filters are temporarily unavailable. Select All to view the collection.');
      }finally{
        if(ticket===generation){grid.style.opacity='';grid.style.minHeight='';}
      }
    }
    function navigate(shape,carat){
      const url=new URL(location.href);
      if(shape==='all')url.searchParams.delete('rx_shape');
      else url.searchParams.set('rx_shape',shape);
      if(carat==='all')url.searchParams.delete('rx_carat');
      else url.searchParams.set('rx_carat',carat);
      url.searchParams.delete('page');
      history.pushState({rxShape:shape,rxCarat:carat},'',url.href);
      display(shape,carat);
    }
    root.addEventListener('click',event=>{
      const link=event.target.closest('[data-rx-shape-choice]');
      if(!link||event.defaultPrevented||event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
      event.preventDefault();
      if(link.getAttribute('aria-disabled')==='true')return;
      navigate(link.dataset.rxShapeChoice,currentFilters().carat);
    });
    caratButtons.forEach(button=>button.addEventListener('click',()=>navigate(currentFilters().shape,button.dataset.rxCaratButton)));
    window.addEventListener('popstate',()=>{
      const state=currentFilters();
      display(state.shape,state.carat);
    });
    const initial=currentFilters();
    if(initial.shape==='all'&&initial.carat==='all')markActive('all','all');
    else display(initial.shape,initial.carat);
  }
  function initAll(){document.querySelectorAll('[data-rx-moissanite-shapes]').forEach(initialize);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);
  else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["roxari-ring-grid-spacing"] && !Shopify.designMode) return;
  try {
    (function () {
  const markerSelector='[data-rx-ring-spacing]';
  const cache=new Map();
  const observed=new WeakSet();
  const sampleWidth=144,sampleHeight=180;
  let intersection=null;

  function calculate(image) {
    const canvas=document.createElement('canvas');
    canvas.width=sampleWidth; canvas.height=sampleHeight;
    const ctx=canvas.getContext('2d',{willReadFrequently:true});
    if(!ctx) return null;
    ctx.drawImage(image,0,0,sampleWidth,sampleHeight);
    const data=ctx.getImageData(0,0,sampleWidth,sampleHeight).data;
    const corners=[[2,2],[sampleWidth-3,2],[2,sampleHeight-3],[sampleWidth-3,sampleHeight-3]];
    const bg=[0,0,0];
    for(const [x,y] of corners){
      const p=(y*sampleWidth+x)*4;
      for(let c=0;c<3;c++)bg[c]+=data[p+c]/corners.length;
    }
    if(Math.min(...bg)<230)return null; // Keep non-white studio backgrounds untouched.
    const rows=new Uint16Array(sampleHeight);
    const cols=new Uint16Array(sampleWidth);
    let total=0;
    for(let y=0;y<sampleHeight;y++)for(let x=0;x<sampleWidth;x++){
      const p=(y*sampleWidth+x)*4;
      if(data[p+3]<180)continue;
      const delta=Math.max(
        Math.abs(data[p]-bg[0]),
        Math.abs(data[p+1]-bg[1]),
        Math.abs(data[p+2]-bg[2])
      );
      if(delta<34)continue;
      rows[y]++;cols[x]++;total++;
    }
    if(total<65 || total>sampleWidth*sampleHeight*.67)return null;
    const xs=[],ys=[];
    for(let x=0;x<sampleWidth;x++)if(cols[x]>=2)xs.push(x);
    for(let y=0;y<sampleHeight;y++)if(rows[y]>=2)ys.push(y);
    if(xs.length<2||ys.length<2)return null;
    const left=xs[0],right=xs[xs.length-1],top=ys[0],bottom=ys[ys.length-1];
    const width=(right-left+1)/sampleWidth;
    const height=(bottom-top+1)/sampleHeight;
    if(width>.93&&height>.93)return null;
    if(Math.max(width,height)<.12)return null;
    // Match the jewelry's visible extent, not the source canvas dimensions.
    // Keep at least ~14% white border around the longest dimension.
    const scale=Math.max(.85,Math.min(1.65,.72/Math.max(width,height)));
    const centerX=(left+right+1)/(2*sampleWidth);
    const centerY=(top+bottom+1)/(2*sampleHeight);
    const dx=(.5-centerX)*scale*100;
    const dy=(.5-centerY)*scale*100;
    return {scale,dx,dy};
  }

  function apply(image,value) {
    if(!value)return;
    image.style.setProperty('transform-origin','center center');
    image.style.setProperty('transform',
      'translate('+value.dx.toFixed(2)+'%, '+value.dy.toFixed(2)+'%) scale('+value.scale.toFixed(3)+')');
  }

  function normalize(image) {
    if(!image.isConnected || !image.complete || !image.naturalWidth)return;
    const url=image.currentSrc||image.src;
    if(!url)return;
    if(cache.has(url)){apply(image,cache.get(url));return;}
    try{
      const result=calculate(image);
      cache.set(url,result);
      apply(image,result);
    }catch(error){
      // Shopify images sometimes use a different asset host. A separate CORS
      // probe is safe: it does not touch the visible image or its loading state.
      const probe=new Image();
      probe.crossOrigin='anonymous';
      probe.onload=function(){
        try{
          const result=calculate(probe);
          cache.set(url,result);
          if(image.isConnected&&(image.currentSrc||image.src)===url)apply(image,result);
        }catch(e){ cache.set(url,null); }
      };
      probe.onerror=function(){cache.set(url,null);};
      probe.src=url;
    }
  }

  function watch(image) {
    if(observed.has(image))return;
    observed.add(image);
    image.addEventListener('load',function(){normalize(image);},{passive:true});
    if(intersection)intersection.observe(image);
    else normalize(image);
  }

  function scan(root) {
    root.querySelectorAll('#CollectionAjaxContent .collection-grid__wrapper > .grid .grid-product img[data-roxari-white-canvas]').forEach(watch);
  }
  function initialize(marker){
    const root=marker.closest('.collection-content');
    if(!root||root.dataset.rxSpacingInitialized==='true')return;
    root.dataset.rxSpacingInitialized='true';
    root.classList.add('rx-ring-spacing-active');
    if('IntersectionObserver' in window&&!intersection){
      intersection=new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          if(entry.isIntersecting){
            intersection.unobserve(entry.target);
            normalize(entry.target);
          }
        });
      },{rootMargin:'350px 0px'});
    }
    let scheduled=false;
    const queue=function(){
      if(scheduled)return;
      scheduled=true;
      requestAnimationFrame(function(){scheduled=false;scan(root);});
    };
    new MutationObserver(queue).observe(root,{childList:true,subtree:true});
    queue();
  }
  function initAll(){
    document.querySelectorAll(markerSelector).forEach(initialize);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);
  else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["roxari-ring-selector-before-shape-sync"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('roxari-ring-selector')) {
  customElements.define('roxari-ring-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.preview = {carat:'0.5',shape:'round',prong:'6',style:'classic'};
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-choice]');
        if (!button || !this.contains(button) || button.disabled) return;
        const group = button.closest('[data-group]').dataset.group;
        this.preview[group] = button.dataset.choice;
        let adjusted = false;
        if (this.preview.shape !== 'round' && this.preview.carat === '0.5') {
          this.preview.carat = '1';
          adjusted = true;
        }
        this.querySelectorAll('[data-group]').forEach(fieldset => {
          const key = fieldset.dataset.group;
          fieldset.querySelectorAll('button[data-choice]').forEach(option => {
            const selected = option.dataset.choice === this.preview[key];
            option.setAttribute('aria-pressed', String(selected));
            if (selected) this.querySelector('[data-current="' + key + '"]').textContent = option.textContent.trim();
          });
        });
        const round = this.preview.shape === 'round';
        this.querySelector('[data-group="carat"] [data-choice="0.5"]').disabled = !round;
        this.querySelector('[data-group="prong"]').hidden = !round;
        
        this.querySelector('[data-preview-status]').textContent = adjusted ? this.dataset.adjustedMessage : '';
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["roxari-ring-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('roxari-ring-selector')) {
  customElements.define('roxari-ring-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.preview = {carat:this.dataset.initialCarat || '0.5',shape:this.dataset.initialShape || 'round',prong:this.dataset.initialProng || null,style:this.dataset.initialStyle || 'classic'};
      this.dataset.previewShape = this.preview.shape;
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-choice]');
        if (!button || !this.contains(button) || button.disabled) return;
        const group = button.closest('[data-group]').dataset.group;
        this.preview[group] = button.dataset.choice;
        if (group === 'shape') {
          this.dataset.previewShape = this.preview.shape;
          this.preview.prong = this.preview.shape === 'round' ? '6' : null;
          this.querySelector('[data-current="prong"]').textContent = this.preview.prong ? '6-Prong Setting' : '';
          this.querySelectorAll('[data-ring-style]').forEach(icon => {
            icon.setAttribute('href', '#' + this.dataset.symbolPrefix + '-ring-' + this.preview.shape + '-' + icon.dataset.ringStyle);
          });
        }
        let adjusted = false;
        if (this.preview.shape !== 'round' && this.preview.carat === '0.5') {
          this.preview.carat = '1';
          adjusted = true;
        }
        this.querySelectorAll('[data-group]').forEach(fieldset => {
          const key = fieldset.dataset.group;
          fieldset.querySelectorAll('button[data-choice]').forEach(option => {
            const selected = option.dataset.choice === this.preview[key];
            option.setAttribute('aria-pressed', String(selected));
            if (selected) this.querySelector('[data-current="' + key + '"]').textContent = key === 'prong' ? this.preview.prong + '-Prong Setting' : option.textContent.trim();
          });
        });
        const round = this.preview.shape === 'round';
        this.querySelector('[data-group="carat"] [data-choice="0.5"]').disabled = !round;
        this.querySelector('[data-group="prong"]').hidden = !round;
        this.querySelector('[data-group="prong"]').disabled = !round;
        
        this.querySelector('[data-preview-status]').textContent = adjusted ? this.dataset.adjustedMessage : '';
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["roxari-ring-shape-filter"] && !Shopify.designMode) return;
  try {
    function rxNavigateFilter(href){
  const target=new URL(href,location.origin);
  const current=new URL(location.href);
  for(const key of ['preview_theme_id','sort_by']){
    if(current.searchParams.has(key))target.searchParams.set(key,current.searchParams.get(key));
  }
  location.assign(target.href);
}
document.addEventListener('click',function(event){
  const link=event.target.closest('[data-rx-ring-filters] a');
  if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button!==0)return;
  event.preventDefault();
  rxNavigateFilter(link.href);
});
document.addEventListener('change',function(event){
  if(event.target.matches('[data-rx-carat]'))rxNavigateFilter(event.target.value);
});
  } catch(e) { console.error(e); }
})();

})();
